import axios from "axios";
import { attachTokenRefresh } from "@/utils/authInterceptors";
import { CLOUD_SERVICE_BASE_URL } from "@/utils/const";
import { notify } from "../utils/notify";
import store from "@/store";

const workflowService = axios.create({
  baseURL: process.env.VUE_APP_ENV === "production"
    ? "https://api.vibrant-wellness.com/v1/ehr/workflow"
    : "https://www.vibrant-america.com/lisapi/v1/ehr/workflow-staging"
});

workflowService.interceptors.request.use(
  async function(config) {
    let token = store?.state?.login?.token || "";
    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

workflowService.interceptors.response.use(
  response => {
    const res = response.data;
    if (![200,204,201].includes(response.status)) {
      notify({
        title: "Error",
        message: response.message,
        type: "error",
        showClose: true,
      });
      return Promise.reject("error");
    }
    else {
      return response;
    }
  },
  error => {
    console.log("err ", error);
    if (error.config && error.config.headers) {
      console.log("auth", error.config.headers.Authorization);
    }
    if (!error.response) {
      notify({
        title: "Error",
        message: error.message,
        type: "error",
        showClose: true,
      });
      return Promise.reject(error);
    }
    // check type for error.response.data first
    if (error.response.data && typeof error.response.data === "object") {
      let { reason, message, errorMessage } = error.response.data;
      if (reason || message || errorMessage) {
        notify({
          title: "Error",
          message: reason || message || errorMessage,
          type: "error",
          showClose: true,
        });
      }
      else {
        notify({
          title: "Error",
          message: error.message,
          type: "error",
          showClose: true,
        });
      }
    }
    else {
      notify({
        title: "Error",
        message: error.message,
        type: "error",
        showClose: true,
      });
    }
    return Promise.reject(error);
  }
);

attachTokenRefresh(workflowService);

export default workflowService;
